'use client';
import cn from 'classnames';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useMemo } from 'react';
import { SERVER_TIME_ZONE, useViewerTimeZone } from '@/hooks/useViewerTimeZone';
import styles from './timezoneinfoheader.module.scss';

interface TimeZoneInfoHeaderProps {
    className?: string;
}

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

export function TimeZoneInfoHeader(props: TimeZoneInfoHeaderProps): React.JSX.Element {
    const viewerTimeZone = useViewerTimeZone();
    const timeZone = useMemo(() => {
        return viewerTimeZone === SERVER_TIME_ZONE ? 'ET' : dayjs().tz(viewerTimeZone).format('z');
    }, [viewerTimeZone]);

    return <header className={cn(styles.header, props.className)}>All times listed {timeZone}</header>;
}
